import CONFIG from '../config';

export const SELECTORS = ', .pt_content #primary ';
export const UBISOFT_PLUS_SUBSCRIPTION_ID = '5c12949ad9d14601d43eea96';

//Style constants
export const UBISOFT_BLUE = '#428ee0'
export const PROMOTION_YELLOW = '#E6BC07';

export const UBISOFT_FONT = '\'Ubisoft Sans Regular\',arial,sans-serif'
export const UBISOFT_BOLD_FONT = '\'Ubisoft Sans Bold\',arial,sans-serif;'
export const UBUNTU_FONT = '\'Ubuntu\',\'Ubisoft Sans Regular\',sans-serif;'
export const CURRENT_FONT = !CONFIG.isUPC ?  UBISOFT_FONT : UBUNTU_FONT;

//Navigation specific breakpoints
export const NAVIGATION_TABLET_MODE= "1450px";
export const NAVIGATION_MOBILE_MODE = "820px";

//Partner games section specific breakpoint
export const PARTNER_GAMES_MOBILE_BREAKPOINT = '720px';

export const TABLET_BREAKPOINT = '1300px';
export const MOBILE_BREAKPOINT = '768px';
